import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import MenuItem from "@material-ui/core/MenuItem"
import { Box, FormControlLabel, Checkbox, FormGroup, Typography } from "@material-ui/core"
import InputLabel from "@material-ui/core/InputLabel"
import FormControl from "@material-ui/core/FormControl"
import Select from "@material-ui/core/Select"
import { KeyboardArrowDown } from "@material-ui/icons"
import { getReviewRequest, setIsCaseAdmin, setReview, updateReviewStatus } from "../../actions/reviewActions"
import { useLocation } from "react-router-dom"

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
	},
	select: {
		...theme.typography.body1,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
		margin: "20px 20px 10px 20px",
	},
	formControl: {
		width: "100%",
	},
	goal: {
		...theme.typography.body1,
		backgroundColor: theme.palette.common.white,
		margin: "0 20px",
	},
	maskAsReview: {
		...theme.typography.body1,
		backgroundColor: theme.palette.common.white,
		borderRadius: "5px",
		margin: "10px 20px",
	},
	title: {
		fontWeight: 500,
	},
}))

const ViewerReview = (props) => {
	const classes = useStyles()
	const [t] = useTranslation("global")
	const dispatch = useDispatch()
	const history = useHistory()
	const theme = useTheme()
	const location = useLocation()
	const { retainedFilterJobData } = props

	const { list, review, reviewBasedOnFileId } = useSelector((state) => state.review)
	const authentication = useSelector((state) => state.authtentication)
	const [selectedReview, setSelectedReview] = useState(0)
	const [reviewGoal, setReviewGoal] = useState("")
	const [markReviewStatus, setMarkReviewStatus] = useState(false)
	const [isMarkReviewApplicable, setIsMarkReviewApplicable] = useState(false)
	const {
		documentDetails: { reviewed, review_assigned_user },
	} = useSelector((state) => state.documentModal)

	const handleChange = (event) => {
		const currentReview = list?.find((item) => item?.id === event.target.value)
		if (currentReview) {
			dispatch(setReview(currentReview))
		}
	}

	const handleReviewChange = (event) => {
		const reviewId = review?.id
		const reviewFileId = location?.pathname?.split("/")?.[3]?.split("?")[0]
		const status = event.target.checked
		dispatch(updateReviewStatus({ reviewId, reviewFileId, status }))
	}

	useEffect(() => {
		if (!_.isEmpty(review)) {
			const reviewFileId = location?.pathname?.split("/")?.[3]?.split("?")[0]
			setSelectedReview(review?.id)
			setReviewGoal(review?.objective)
			const markReview = reviewed
			setIsMarkReviewApplicable(markReview)
			setMarkReviewStatus(markReview || false)
		}
	}, [review, reviewed])

	useEffect(() => {
		if (!_.isEmpty(reviewBasedOnFileId)) {
			const reviewFileId = location?.pathname?.split("/")?.[3]?.split("?")[0]
			setSelectedReview(review?.id)
			setReviewGoal(review?.objective)
			const markReview = reviewed
			setIsMarkReviewApplicable(markReview)
			setMarkReviewStatus(markReview || false)
		}
	}, [reviewBasedOnFileId])

	useEffect(() => {
		if (list.length && retainedFilterJobData?.additional_params?.review_id && !review?.id) {
			const selectedReviewId = retainedFilterJobData?.additional_params?.review_id
			const is_case_admin = retainedFilterJobData?.additional_params?.is_case_admin || false
			const currentReview = list?.find((item) => item?.id === selectedReviewId)
			if (currentReview) {
				dispatch(setIsCaseAdmin(is_case_admin))
				dispatch(setReview(currentReview))
			}
		}
	}, [retainedFilterJobData, list, reviewBasedOnFileId])

	return (
		<Box className={classes.root}>
			<Box className={classes.select}>
				<FormGroup row>
					<FormControl variant="outlined" className={classes.formControl}>
						<InputLabel id="demo-simple-select-outlined-label">{"Review"}</InputLabel>
						<Select
							id="review-select"
							IconComponent={() => {
								return <KeyboardArrowDown />
							}}
							className={"qa-review-select"}
							value={selectedReview}
							onChange={handleChange}
							label={t("review.viewerReview.review")}
						>
							{reviewBasedOnFileId?.map((item) => {
								return <MenuItem value={item?.id}>{item?.name}</MenuItem>
							}, [])}
						</Select>
					</FormControl>
				</FormGroup>
			</Box>
			<Box className={classes.goal}>
				<Typography variant="body2" component="p" className={classes.title}>
					{t("review.viewerReview.goal")}
				</Typography>
				<Typography variant="body2" component="p">
					{reviewGoal}
				</Typography>
			</Box>
			<Box className={classes.maskAsReview}>
				{isMarkReviewApplicable !== undefined && review_assigned_user === authentication.user.token.userid && (
					<FormControl>
						<FormControlLabel
							control={
								<Checkbox
									className="qa-mark-as-review-checkbox"
									checked={markReviewStatus}
									onChange={handleReviewChange}
									name="checkedB"
									color="primary"
								/>
							}
							label={t("review.viewerReview.markAsReview")}
						/>
					</FormControl>
				)}
			</Box>
		</Box>
	)
}

export default ViewerReview
